import React from 'react';
import Login from './Login/Login';

function App() {
    const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
    if (path) {
        window.location.href.replace(path);
    }
  return (
    <>
      <Login/>
    </>
  );
}

export default App;
